import React from 'react';
import {
  DndGoalListCard,
  GoalListCard,
} from 'shared/components/ui/goal-list-card';

export type GoalListItemProps = React.ComponentProps<typeof GoalListCard> & {
  onPremium: () => void;
  hasDnd?: boolean;
};

export const GoalListItem: React.FC<GoalListItemProps> = ({
  goal,
  onPremium,
  onClick,
  hasDnd,
  ...rest
}) => {
  const _onClick = goal.frozenAt ? onPremium : onClick;

  return hasDnd ? (
    <DndGoalListCard goal={goal} onClick={_onClick} {...rest} />
  ) : (
    <GoalListCard goal={goal} onClick={_onClick} {...rest} />
  );
};
